import { Infer, object, string } from "superstruct";

export const insuranceQuoterSchema = object({
  title: string(),
  newCustomerLabel: string(),
  existingCustomerLabel: string(),
  newCustomerDescription: string(),
  existingCustomerDescription: string(),
  plateInputLabel: string(),
  plateInputPlaceholder: string(),
  plateRequiredError: string(),
  platePatternError: string(),
  birthdateInputLabel: string(),
  dayInputPlaceholder: string(),
  monthInputPlaceholder: string(),
  yearInputPlaceholder: string(),
  birthdateRequiredError: string(),
  birthdatePatternError: string(),
  ctaLabel: string(),
  newCustomerRedirectUrl: string(),
  existingCustomerRedirectUrl: string(),
  backgroundImageSrc: string(),
  dataTrackingForNewCustomer: string(),
  dataTrackingForExistingCustomer: string(),
  dataPosition: string(),
});

type CfInsuranceQuoterSchema = Infer<typeof insuranceQuoterSchema>;
export type CfInsuranceQuoterProps = {
  dataJson: CfInsuranceQuoterSchema;
};
